module.exports = __webpack_public_path__ + "media/src/img/left-flowers-ca8105f8b59e50197e0f39306120c0fb.png";